import _ from "lodash"
import { pushDataLayer } from "./pushDataLayer"
import { GTM_VIEW_RECOMMENDED_MENU } from "constant"
import { ImdfFeature } from "providers/venue/types"

export const gtmPushDataLayerViewRecommendedMenu = (feature: ImdfFeature) => {
  const localCategoriesName = _.map(
    feature?.properties?.local_categories,
    (taxonomy) => _.get(taxonomy, "properties.name.en")
  ).join(",")
  pushDataLayer({
    event: GTM_VIEW_RECOMMENDED_MENU,
    feature_id: _.get(feature, "id"),
    feature_type: _.get(feature, "feature_type"),
    feature_name: _.get(feature, "properties.name.en"),
    feature_category: _.get(feature, "properties.category"),
    local_categories: localCategoriesName,
  })
}
